export default __webpack_public_path__ + "static/media/warning-inActive.d6801d83.svg";